<template>
  <v-col cols="12" lg="3" sm="6">
    <v-card :loading="loading" class="mx-auto" height="180">
      <template #progress>
        <v-progress-linear color="indigo" indeterminate />
      </template>

      <v-card-text class="text-h6 font-weight-black"> Faixa etária </v-card-text>

      <apexchart v-if="hasData" height="100" :options="chartOptions" :series="series" />

      <div v-else class="d-flex align-center justify-center text-grey" style="height: 100px">
        Sem registros de faixa etária
      </div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "FaixaEtariaCard",

  props: {
    franquiaId: {
      default: null,
      type: Number,
    },
  },

  data() {
    return {
      chartOptions: {
        chart: {
          height: 400,
          offsetX: -20,
          type: "donut",
        },

        labels: ["0-6", "6-15", "15-18", "18+"],

        legend: {
          offsetY: -20,
          show: true,
        },

        responsive: [
          {
            breakpoint: 400,
            options: {
              chart: {
                width: 400,
              },

              legend: {
                offsetY: -80,
                position: "bottom",
              },
            },
          },
        ],
      },

      loading: false,

      series: [],
    };
  },

  computed: {
    hasData() {
      return this.series.some((value) => value > 0);
    },
  },

  watch: {
    franquiaId: {
      handler(value) {
        this.getFaixaEtaria(value);
      },

      immediate: true,
    },
  },

  methods: {
    async getFaixaEtaria(franquiaId) {
      if (!franquiaId) {
        this.series = [];
        return;
      }

      this.loading = true;

      try {
        const { data } = await this.$services.alunosService.faixaEtaria(franquiaId);

        const faixaEtaria = data?.[0] ?? {};

        this.series = [
          faixaEtaria.de0a6,
          faixaEtaria.de6a15,
          faixaEtaria.de15a18,
          faixaEtaria.mais18,
        ].map((value) => Number(value) || 0);
      } catch (error) {
        console.error("Erro ao carregar dados de faixa etária:", error);
        this.series = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
